.fp-logo(data-test='club-logo' :class='{"-lg": lg}')
  img(:src='logoUrl' :alt='t("logo.alt.club")')
